<template lang="pug">
    div
        div(v-if="validAgents")
            Agent(
                v-for='agent in agents'
                :key='agent.account_user_id'
                :agent="agent"
                :set-current-campaign-customer="setCurrentCampaignCustomer"
            )

        v-col(cols='12' v-else)
            v-alert(type="error" dense)
                | Zero agents online

</template>

<script lang="ts">
    import Vue from 'vue';

    // Components
    import Agent from '@/components/dashboards/live/messages/agent.vue';

    export default Vue.extend({
        data() {
            return {
            }
        },
        methods: {
        },
        computed: {
            validAgents() {
                return this.agents?.length > 0;
            },
        },
        components: {
            Agent,
        },
        props: {
            agents: Array,
            setCurrentCampaignCustomer: Function,
        },
        watch: {
        },
        created() {
        },
    });
</script>

<style lang="scss" scoped>
</style>